var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationKnowledge = function SvgNotificationKnowledge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M10.21 10.127c.61 0 1.107-.494 1.108-1.105v0c0-.31-.124-.609-.344-.828l-.735-.735V5.274A3.236 3.236 0 0 0 7 2.04v0a3.235 3.235 0 0 0-3.234 3.234v2.183l-.734.735a1.17 1.17 0 0 0-.346.828v0a1.109 1.109 0 0 0 1.109 1.106z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M6.137 11.96h1.726"
  })));
};
export { SvgNotificationKnowledge as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZTgyNTQ1Nzc5NjA1OTJiYmY4OTFkMGI3ZDUyOTczZjYuc3ZnIjs=";